import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import c from "./uploadFileDialog.ce.vue.js";
import { vCopyVueucStylesToShadowDom as d } from "../../utils/vCopyVueucStylesToShadowDom.js";
import { vShadowPropertyPolyfill as h } from "../../utils/vShadowPropertyPolyfill.js";
import { defineComponent as v, useTemplateRef as C, computed as _, withDirectives as y, openBlock as g, createBlock as P, withCtx as l, createVNode as m } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useShadowRoot as w } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { ref as D, unref as o } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import N from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/common/zhCN.js";
import R from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/date/zhCN.js";
import x from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/config-provider/src/ConfigProvider.js";
import { NDialogProvider as F } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/dialog/src/DialogProvider.js";
import S from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/MessageProvider.js";
const s = "blue", A = /* @__PURE__ */ v({
  name: "UploadFileDialogEntry",
  __name: "index.ce",
  setup(k, { expose: f }) {
    const r = w(), a = C("uploadFileDialogRef"), i = {
      blue: "#2980ff",
      orange: "#FC9153"
    }, n = D(i[s]), u = _(() => {
      const e = n.value;
      return {
        common: {
          primaryColor: e,
          primaryColorHover: e,
          primaryColorPressed: e,
          primaryColorSuppl: e
        }
      };
    });
    return f({ open: (e) => {
      var p;
      n.value = i[e.themeColor || s];
      const t = (p = a.value) == null ? void 0 : p.open(e);
      return t instanceof Promise ? t : new Promise((b) => {
      });
    } }), (e, t) => y((g(), P(o(x), {
      locale: o(N),
      "date-locale": o(R),
      "theme-overrides": u.value,
      "style-mount-target": o(r)
    }, {
      default: l(() => [
        m(o(S), { to: o(r) }, {
          default: l(() => [
            m(o(F), { to: o(r) }, {
              default: l(() => [
                m(c, {
                  ref_key: "uploadFileDialogRef",
                  ref: a
                }, null, 512)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["locale", "date-locale", "theme-overrides", "style-mount-target"])), [
      [o(d), o(r)],
      [o(h), o(r)]
    ]);
  }
});
export {
  A as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/upload-file-dialog/index.ce.vue2.js
// module id = 1332
// module chunks = 67